import { Link } from 'react-router-dom';
import { comics, categories } from '@/mocks/comics';

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {categories.slice(0, 4).map((cat) => {
          const catComics = comics.filter((c) => c.genres.includes(cat.slug)).slice(0, 4);
          if (catComics.length === 0) return null;
          return (
            <div key={cat.slug} className="mb-10 last:mb-0">
              <div className="flex items-center justify-between mb-6">
                <div className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-50">
                    <i className={`${cat.icon} text-primary-500`}></i>
                  </div>
                  <h3 className="font-heading text-xl font-bold text-foreground-900">
                    {cat.name}
                  </h3>
                </div>
                <Link
                  to={`/category/${cat.slug}`}
                  className="text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
                >
                  查看全部 <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-5" data-product-shop>
                {catComics.map((comic) => (
                  <Link
                    key={comic.id}
                    to={`/comic/${comic.id}`}
                    className="group cursor-pointer"
                  >
                    <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200/70 mb-3">
                      <img
                        src={comic.cover}
                        alt={comic.title}
                        title={`${comic.title} - ${cat.name}韩漫`}
                        className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                      />
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
                        <div className="flex items-center gap-1 text-white/90 text-xs">
                          <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                          <span>{comic.rating}</span>
                        </div>
                      </div>
                    </div>
                    <h4 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors truncate">
                      {comic.title}
                    </h4>
                    <p className="text-xs text-foreground-500 mt-0.5 truncate">{comic.author}</p>
                  </Link>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}